export default {
  pageTitle: 'Limited-time deal',
  manageTitle: 'Limited-time deal management',
  productsTitleTab: 'Add Limited-time deal',
  manageTitleTab: 'Limited-time deal management',
  sTitle: 'Please enter title',
  sListingId: 'Please enter Listing ID',
  sSkuId: 'Please enter Sku ID',
  sStartTime: 'Start time',
  sEndTime: 'End time',

  tbListingId: 'Listing ID',
  tbProductInfo: 'Product information',
  tbSalePrice: 'Selling Price',
  tbDealPrice: 'Event Price',
  tbStock: 'Inventory',
  tbSkuInfo: 'Sku information',
  tbStatus: 'Status',
  tbActivateTime: 'Event Time',
  tbAction: 'Operation',
  tbErr: 'Error tips:',
  errTips1: 'Event price must be > 0.',
  errTips2: 'Event price must be lower than the selling price.',
  errTips3: 'Event time cannot be empty',
  errTips4: 'The end time of the activity must be greater than the start time.',
  errTips5: 'Total duration of the promotion cannot exceed 30 days.',
  errTips6: 'Limit per order must be greater than 0',
  limitPerOrder: 'Single Purchase Limit',
  limitPerOrderPlaceholder: 'Select limit',
  limitPerOrderOption0: 'No Limit',
  limitPerOrderOption1: 'Limit 1',
  limitPerOrderOption2: 'Limit 2',
  limitPerOrderOption3: 'Limit 3',
  limitPerOrderOption4: 'Limit 4',
  limitPerOrderOption5: 'Limit 5',

  status0: 'All',
  status1: 'In Progress',
  status2: 'Expired',
  status3: 'To be started',

  succTips: 'Operation succeeded.',
  errTips: 'Submission failed, some SKUs do not meet the requirements,Sku id: {ids}',
  fixedAmount: 'Amount',
  discount: 'Fixed Discount',
  batchSetting: 'Batch Settings',
  reduce: 'Reduce',

  searchBtn: 'Search',
  resetBtn: 'Reset',
  submitBtn: 'Submit',
  cancelBtn: 'Cancel',
  editBtn: 'Edit',
  confirm: 'Confirm',
  delBtn: 'Delete',
  previewActivateBtn: 'Click to view other events.',

  cancelTips: 'Confirm Cancellation?',
  delTips: 'Confirm Delete?',
  an: '',
  closeDialog: 'The content will be cleared after closing. Are you sure to close?'
}
